/* eslint-disable */
import React from 'react';
import { connect } from 'react-redux';
import { Button } from 'react-bootstrap';
import Revision from './Revision';
import Loading from './Loading';
import { revisionFetchIsLoading, revisionFetchHasErrored, revision } from '../actions/actionCreator';

const mapStateToProps = (state) => ({
  siteIdCurrent: state.siteId,
  loading: state.revisionFetchIsLoading,
  revisionCurrent: state.revision,
  openedFolderCurrent: state.openedFolder,
  openedFileCurrent: state.openedFile,
});

const mapDispatchToProps = (dispatch) => ({
  revisionFetchIsLoading: (isLoading) => dispatch(revisionFetchIsLoading(isLoading)),
  revisionFetchHasErrored: (hasErrored) => dispatch(revisionFetchHasErrored(hasErrored)),
  revision: (revisionLoaded) => dispatch(revision(revisionLoaded)),
});

class RevisionHistory extends React.Component {
  state = { page: 0 };

  getNewPage(page) {
    document.getElementById('fileRevision').scrollTop = 0;
    this.props.callDVS(
      this.props.revisionFetchIsLoading,
      this.props.revisionFetchHasErrored,
      this.props.revision,
      'REVISION',
      this.props.siteIdCurrent,
      this.props.openedFolderCurrent,
      this.props.openedFileCurrent,
      null,
      page,
    );
  }

  handleGetOlderRevisions() {
    this.getNewPage(this.state.page + 1);
    this.setState({ page: this.state.page + 1 });
  }

  handleGetNewerRevisions() {
    this.getNewPage(this.state.page - 1);
    this.setState({ page: this.state.page - 1 });
  }

  componentDidUpdate(prevProps) {
    if (prevProps.openedFileCurrent !== this.props.openedFileCurrent) {
      this.setState({ page: 0 });
    }
  }

  render() {
    if (this.props.loading) return (<Loading />);
    return (
      <div className="history">
        {Object.keys(this.props.revisionCurrent).map((key) => (
          <Revision
            key={key}
            id={key}
            revisionCurrent={this.props.revisionCurrent}
            callDVS={this.props.callDVS}
            routeHandler={this.props.routeHandler}
            page={this.state.page}
          />
        ))}
        {this.state.page > 0 && (
          <Button className="newer" onClick={() => this.handleGetNewerRevisions()}>Get Newer Revisions</Button>
        )}
        {this.props.revisionCurrent.length === 100 && this.props.revisionCurrent[99].date.daysOld < 180 && (
          <Button className="older" onClick={() => this.handleGetOlderRevisions()}>Get Older Revisions</Button>
        )}
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(RevisionHistory);
